import { render } from "./ModalInformativoProdutos.vue?vue&type=template&id=7d47343f&scoped=true"
import script from "./ModalInformativoProdutos.vue?vue&type=script&lang=js"
export * from "./ModalInformativoProdutos.vue?vue&type=script&lang=js"

import "./ModalInformativoProdutos.vue?vue&type=style&index=0&id=7d47343f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d47343f"]])

export default __exports__